import { __rest } from "tslib";
import { IS_CLIENT } from '../constants';
const SCRIPT_STATUSES = {
    EXISTS: 'EXISTS',
    LOADED: 'LOADED',
    ERROR: 'ERROR',
};
const loadedScripts = {};
/**
 * Inject script tag in the HEAD part of the web page. If script already exist nothing will happen
 *
 * @param {Object} - Options object for new HTMLScriptElement
 * src -  source url of the script that should be loaded
 * onStateUpdate - Callback function with two arguments (status, SCRIPT_STATUSES)
 *
 * @return {HTMLScriptElement | null} new observer, can be used to disconnect
 */
const injectScriptTag = (_a) => {
    var { src, onStateUpdate } = _a, additionalAttributes = __rest(_a, ["src", "onStateUpdate"]);
    if (!IS_CLIENT)
        return null;
    const isCurrentScriptLoaded = !!src && loadedScripts[src];
    const currentScript = isCurrentScriptLoaded
        ? document.querySelector(`script[src="${src}"]`)
        : null;
    if (isCurrentScriptLoaded) {
        onStateUpdate === null || onStateUpdate === void 0 ? void 0 : onStateUpdate(SCRIPT_STATUSES.EXISTS, SCRIPT_STATUSES);
        return null;
    }
    if (currentScript && !isCurrentScriptLoaded) {
        currentScript.addEventListener('load', () => {
            onStateUpdate(SCRIPT_STATUSES.LOADED, SCRIPT_STATUSES);
        });
        currentScript.addEventListener('error', () => {
            onStateUpdate(SCRIPT_STATUSES.ERROR, SCRIPT_STATUSES);
        });
        return null;
    }
    const script = document.createElement('script');
    if (src) {
        script.setAttribute('src', src);
        script.setAttribute('defer', 'true');
    }
    Object.keys(additionalAttributes).forEach((attribute) => {
        script.setAttribute(attribute, additionalAttributes[attribute]);
    });
    script.addEventListener('load', () => {
        loadedScripts[src] = true;
        onStateUpdate === null || onStateUpdate === void 0 ? void 0 : onStateUpdate(SCRIPT_STATUSES.LOADED, SCRIPT_STATUSES);
    });
    script.addEventListener('error', () => {
        loadedScripts[src] = true;
        onStateUpdate === null || onStateUpdate === void 0 ? void 0 : onStateUpdate(SCRIPT_STATUSES.ERROR, SCRIPT_STATUSES);
    });
    document.head.appendChild(script);
    return script;
};
export default injectScriptTag;
//# sourceMappingURL=injectScriptTag.js.map